export default "__VITE_ASSET__BfKYdJwP__"